import { ColorSAP } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.DrawerMenu = styled("div")(() => ({
    position: "relative",
    marginBottom: 48,
    wordBreak: "break-word"
}));

Styled.DrawerMenuLabel = styled("div")(() => ({
    cursor: "pointer",
    marginLeft: 2,
}));

Styled.DrawerMenuIsCustomizedTag = styled("div")(() => ({
    position: "absolute",
    top: 2,
    left: 0,
    width: 8,
    height: 8,
    background: ColorSAP.secondary[40],
    borderRadius: "50%",
    zIndex: 99999,
}));

export default Styled;
